export var PdfViewerPageLayer;
(function (PdfViewerPageLayer) {
    PdfViewerPageLayer["PdfCanvas"] = "PDF Canvas";
    PdfViewerPageLayer["PdfText"] = "PDF Text";
    PdfViewerPageLayer["PdfAnnotations"] = "PDF Annotation";
    PdfViewerPageLayer["PdfEmbeddedMedia"] = "PDF Embedded Media";
    PdfViewerPageLayer["Annotations"] = "Annotations";
})(PdfViewerPageLayer || (PdfViewerPageLayer = {}));
export var PdfViewerPageClasses;
(function (PdfViewerPageClasses) {
    PdfViewerPageClasses["Page"] = "sp-pdf-viewer-page";
    PdfViewerPageClasses["CanvasLayer"] = "sp-pdf-viewer-page__pdf-canvas-layer-wrapper";
    PdfViewerPageClasses["MediaLayer"] = "sp-pdf-viewer-page__pdf-embedded-media-layer-wrapper";
    PdfViewerPageClasses["TextLayer"] = "sp-pdf-viewer-page__pdf-text-layer-wrapper";
    PdfViewerPageClasses["PdfAnnotationLayer"] = "sp-pdf-viewer-page__pdf-annotation-layer-wrapper";
    PdfViewerPageClasses["AnnotationLayer"] = "sp-pdf-viewer-page__annotation-layer-wrapper";
    PdfViewerPageClasses["IsAnnotating"] = "sp-pdf-viewer-page--is-annotating";
})(PdfViewerPageClasses || (PdfViewerPageClasses = {}));
//# sourceMappingURL=pdf-viewer-page.component.type.js.map